import { useFreshBundle } from "@/lib/use-fresh-bundle";

// F33.3 — top-of-shell banner that surfaces when a newer admin bundle
// is live on origin. Click to hard-reload the tab; the new bundle takes
// over without the operator needing to know about cache-busting.
export function StaleBundleBanner() {
	const isStale = useFreshBundle();
	if (!isStale) return null;

	return (
		<div
			role="status"
			className="sticky top-0 z-50 flex items-center justify-center gap-3 bg-amber-500 px-4 py-2
				text-sm font-medium text-amber-950 shadow"
		>
			<span>A newer version of the console is available.</span>
			<button
				type="button"
				onClick={() => window.location.reload()}
				className="rounded-md bg-amber-950 px-3 py-1 text-xs font-semibold text-amber-50
					hover:bg-amber-900"
			>
				Reload
			</button>
		</div>
	);
}
